import { useCallback, useMemo, useState } from 'react';
export const useRowSelection = () => {
    const [selected, setSelected] = useState({});
    const hasAnySelected = useMemo(() => Object.keys(selected).some(x => selected[x]), [selected]);
    const isSelected = useCallback((id) => !!selected[id], [selected]);
    return {
        isSelected,
        toggleSelected: (id) => setSelected(x => (Object.assign(Object.assign({}, x), { [id]: !x[id] }))),
        resetSelected: () => setSelected({}),
        selected,
        getSelected: () => Object.keys(selected).filter(x => selected[x]),
        hasAnySelected,
        setSelected,
        selectAll: (ids) => setSelected(old => {
            var newValue = Object.assign({}, old);
            ids.forEach(id => {
                newValue[id] = true;
            });
            return newValue;
        }),
    };
};
